import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const hubspotContactsAdapter = createEntityAdapter({})

const initialState = hubspotContactsAdapter.getInitialState()

export const hubspotContactsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHubspotContacts: builder.query({
            query: () => ({
                url: '/services/integration/hubspot/contacts',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedHubspotContacts = responseData.contacts.map(hubspotContact => {
                    hubspotContact.id = hubspotContact._id
                    return hubspotContact
                })
                return hubspotContactsAdapter.setAll(initialState, loadedHubspotContacts)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'HubspotContact', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'HubspotContact', id}))
                    ]
                } else {
                    return [ { type: 'HubspotContact', id: 'LIST'}]
                }
            },
        }),
        // NEW: HubSpot Connect Mutation
        connectHubspot: builder.mutation({
            query: () => ({
                url: '/services/integration/hubspot/auth',
                method: 'GET',
            }),
        }),
    }),
})

export const {
    useGetHubspotContactsQuery,
    useConnectHubspotMutation,  
} = hubspotContactsApiSlice

// returns the query result object
export const selectHubspotContactResult = hubspotContactsApiSlice.endpoints.getHubspotContacts.select()

// create memoized selector
const selectHubspotContactsData = createSelector(
    selectHubspotContactResult,
    hubspotContactResult => hubspotContactResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllHubspotContacts,
    selectById: selectHubspotContactById,
    selectIds: selectHubspotContactIds,
} = hubspotContactsAdapter.getSelectors(state => selectHubspotContactsData(state) ?? initialState)